// User prefers `8,800` not `8.8K` — full thousands separator everywhere.
const fmt = new Intl.NumberFormat('en-US');

export function formatCount(n: number | undefined | null): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return fmt.format(n);
}

export function formatPercent(num: number | undefined, denom: number | undefined): string {
  if (!num || !denom) return '—';
  return `${((num / denom) * 100).toFixed(1)}%`;
}
